module.exports = __webpack_public_path__ + "static/media/5.a8fdbd0b.jpg";